import DealTaxesDetails from './DealTaxesDetails';

export { DealTaxesDetails };
